<template>
<router-link :to="{ name, params, query }">
  <icon v-if="leftIcon" :icon="leftIcon"/>
  <span>
    <slot></slot>
  </span>
  <icon v-if="leftRight" :icon="leftRight"/>
</router-link>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    query: {
      type: Object,
      default: () => ({})
    },
    leftIcon: {
      type: String
    },
    leftRight: {
      type: String
    }
  }
}
</script>